<template>
    <div id="dashboard">
        <div class="title">
            <p>门票数据</p>
            <div class="form-query">
                <span class="form-item-label">店铺名称：</span>
                <el-select style="width: 300px;" v-model="shop_id" filterable placeholder="请选择" @change="onShopChange">
                    <el-option label="全部" value="all"></el-option>
                    <el-option v-for="shop in shop_opt" :key="shop.shop_id" :label="shop.name" :value="shop.shop_id"></el-option>
                </el-select>
            </div>
        </div>
        <div class="chart">
            <el-card v-loading="loading">
                <!-- <div class="chart-title">门票数据</div> -->
                <div class="data-show">
                    <div class="show-span">
                        <div class="ring ring1">
                            <img src="@/assets/icon/baby-paradise/icon_renshu@2x.png" alt="">
                        </div>
                        <span class="key">累计购票人次</span>
                        <!-- <span class="value">{{ all_sum }}</span> -->
                        <span class="value">
                            <countTo :startVal='0' :endVal='all_sum' :duration='3000'></countTo>    
                        </span>
                    </div>
                    <div class="show-span">
                        <div class="ring ring2">
                            <img src="@/assets/icon/baby-paradise/icon_xinzenges@2x.png" alt="">
                        </div>
                        <span class="key">月度购票人次</span>
                        <!-- <span class="value">{{ month_sum }}</span> -->
                        <span class="value">
                            <countTo :startVal='0' :endVal='month_sum' :duration='3000'></countTo>  
                        </span>
                    </div>
                    <div class="show-span">
                        <div class="ring ring3">
                            <img src="@/assets/icon/baby-paradise/icon_renshupf@2x.png" alt="">
                        </div>
                        <span class="key">昨日销售额（元）</span>
                        <!-- <span class="value">{{ yesterday_price }}</span> -->
                        <span class="value">
                            <countTo :startVal='0' :endVal='yesterday_price' :suffix="suffix1" :duration='3000'></countTo>    
                        </span>
                    </div>
                    <div class="show-span">
                        <div class="ring ring4">
                            <img src="@/assets/icon/baby-paradise/icon_hexiaors@2x.png" alt="">
                        </div>
                        <span class="key">截至昨日零时已核销金额</span>
                        <!-- <span class="value">{{ end_yesterday_price }}</span> -->
                        <span class="value">
                            <countTo :startVal='0' :endVal='end_yesterday_price' :suffix="suffix2" :duration='3000'></countTo>      
                        </span>
                    </div>
                </div>
            </el-card>
            <div class="chart-data">
                <el-row :gutter="20">
                    <el-col :span="16">
                        <el-card>
                            <div class="chart-title">
                                <div style="font-size: 22px;">销售额明细</div>
                                <div class="chart-tabs">
                                    <el-tabs v-model="salesActiveName" @tab-click="handleClick(salesActiveName, 1)">
                                        <el-tab-pane label="近7天" name="1"></el-tab-pane>
                                        <el-tab-pane label="近30天" name="2"></el-tab-pane>
                                        <el-tab-pane label="近1年" name="3"></el-tab-pane>
                                    </el-tabs>
                                </div>
                            </div>
                            <div v-loading="loading1" id="salesEchart" style="width: 100%;height: 500px;"></div>
                        </el-card>
                        <el-card style="margin-top: 12px;">
                            <div class="chart-title">
                                <div style="font-size: 22px;">核销金额明细</div>
                                <div class="chart-tabs">
                                    <el-tabs v-model="chargeActiveName" @tab-click="handleClick(chargeActiveName, 2)">
                                        <el-tab-pane label="近7天" name="4"></el-tab-pane>
                                        <el-tab-pane label="近30天" name="5"></el-tab-pane>
                                        <el-tab-pane label="近1年" name="6"></el-tab-pane>
                                    </el-tabs>
                                </div>
                            </div>
                            <div v-loading="loading2" id="chargeEchart" style="width: 100%;height: 500px;"></div>
                        </el-card>
                    </el-col>
                    <el-col :span="8">
                        <el-card v-loading="loading">
                            <div class="table-title">门票销量排行榜</div>
                            <el-table :data="tableData" style="width: 100%;min-height:500px;">
                                <el-table-column prop="ranking" label="排名"></el-table-column>
                                <el-table-column prop="name" label="景区名称"></el-table-column>
                                <el-table-column prop="num" label="累计销量 (件)"></el-table-column>
                            </el-table>
                        </el-card>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
import { whichWeek } from '@/utils/computing-time.js';
import { getEcharts, getStatistics } from '@/api/baby/data.js';
import countTo from 'vue-count-to';
import { mapActions } from 'vuex';
import { getShopStorage } from '@/utils/storage.js';
export default {
    components: { countTo },
    data () {
        return {
            data: [
                { ranking: 1, name: '暂无', num: 0 },
                { ranking: 2, name: '暂无', num: 0 },
                { ranking: 3, name: '暂无', num: 0 },
                { ranking: 4, name: '暂无', num: 0 },
                { ranking: 5, name: '暂无', num: 0 },
                { ranking: 6, name: '暂无', num: 0 },
                { ranking: 7, name: '暂无', num: 0 },
                { ranking: 8, name: '暂无', num: 0 },
                { ranking: 9, name: '暂无', num: 0 },
                { ranking: 10, name: '暂无', num: 0 }
            ],
            salesActiveName: '1',
            chargeActiveName: '4',
            salesEchart: null,
            chargeEchart: null,
            loading: false,
            loading1: false,
            loading2: false,
            yearWeek: [],
            all_sum: 0,             // 累计购票人次
            end_yesterday_price: 0, // 截止昨日零时已核销金额
            month_sum: 0,           // 本月购票人次
            yesterday_price: 0,     // 昨日销售金额
            suffix1: ".00",
            suffix2: ".00",
            shop_id: 'all',
            shop_opt: [],           // 店铺列表
            shop_id_list: [],       // 店铺shop_id列表

        }
    },
    computed: {
        tableData () {
            return this.data.filter((item, index) => {
                return index < 10
            })
        }
    },
    methods: {
        ...mapActions('newshop', ['getshopIdName']),
        // 切换店铺
        onShopChange () {
            this.getStatistics();
            this.initEchart({ value2: 1, options: this.salesActiveName });
            this.initEchart({ value2: 2, options: this.chargeActiveName });
        },
        // 整合切换时间加载echarts事件
        handleClick (options, value2) {
            if (value2 == 1) {
                this.loading1 = true;
                echarts.init(document.getElementById('salesEchart')).dispose();
            } else if (value2 == 2) {
                this.loading2 = true;
                echarts.init(document.getElementById('chargeEchart')).dispose();
            }
            let data = {
                options,
                value2,
            }
            this.initEchart(data);
        },
        initEchart (data) {
            if (data.value2 == 1) {
                this.loading1 = true;
            } else if (data.vlaue2 == 2) {
                this.loading2 = true;
            }
            this.initEchartData(data)
                .then(res => {
                    if (data.value2 == 1) {
                        this.initSalesChart(res.data.data.list, data.options);
                    } else if (data.value2 == 2) {
                        this.initChargeChart(res.data.data.list, data.options);
                    }
                })
                .catch(err => {
                    this.$message.error(err.msg);
                })
                .finally(_ => {
                    if (data.value2 == 1) {
                        this.loading1 = false;
                    } else if (data.value2 == 2) {
                        this.loading2 = false;
                    }
                })
        },
        initSalesChart (data, value) {
            this.salesEchart = echarts.init(document.getElementById('salesEchart'));
            let options = {
                tooltip: {},
                xAxis: {
                    axisLabel: {
                        interval: 0,
                        formatter: function(value) {
                            if (value.indexOf('&') > -1) {
                                // return value.split('&')[0] + '\n' + value.split('&')[1]
                                return value.split('&')[1] + '\n' + value.split('&')[0]
                            } else {
                                return value
                            }
                        }
                    },
                },
                yAxis: {},
                dataZoom: [
                    {
                        "type": "inside"
                    },  
                    {
                        "type": "slider"
                    },  
                ],
                grid: {
                    bottom: 90
                },
                series: [
                    {
                        name: '销售金额',
                        type: 'bar',
                        barWidth: 30,
                        legendHoverLink: true,
                        label: {
                            show: true,
                            position: "top"
                        }
                    }
                ]
            }
            let data1 = [];
            let data2 = [];
            if (value == 1) {
                data1 = data.map(item => {
                    return item.days
                })
            } else if (value == 2) {
                data1 = data.map(item => {
                    let oneDay = this.yearWeek[item.weeks-1].month + '月' + this.yearWeek[item.weeks-1].date + '日',
                        lastDay = this.yearWeek[item.weeks-1].last.month + '月' + this.yearWeek[item.weeks-1].last.date + '日';
                    return oneDay + '-' + lastDay + '&' + '第' + item.weeks + '周'
                })
            } else if (value == 3) {
                data1 = data.map(item => {
                    return item.months
                    // return item.months.split('-')[1] + '月'
                })
            }
            data2 = data.map(item => {
                return item.price_order
            })
            options.xAxis.data = data1;
            options.series[0].data = data2;
            this.salesEchart.setOption(options);
        },
        initChargeChart (data, value) {
            this.chargeEchart = echarts.init(document.getElementById('chargeEchart'));
            let options = {
                tooltip: {},
                xAxis: {
                    axisLabel:{
                        interval: 0,
                        formatter: function(value) {
                            if (value.indexOf('&') > -1) {
                                // return value.split('&')[0] + '\n' + value.split('&')[1]
                                return value.split('&')[1] + '\n' + value.split('&')[0]
                            } else {
                                return value
                            }
                        }
                    },
                },
                yAxis: {},
                dataZoom: [
                    {
                        "type": "inside"
                    },  
                    {
                        "type": "slider"
                    }  
                ],
                grid: {
                    bottom: 90
                },
                series: [
                    {
                        name: '核销金额',
                        type: 'bar',
                        barWidth: 30,
                        legendHoverLink: true,
                        label: {
                            show: true,
                            position: "top"
                        }
                    }
                ]
            }
            let data1 = [];
            let data2 = [];
            if (value == 4) {
                data1 = data.map(item => {
                    return item.days
                })
            } else if (value == 5) {
                data1 = data.map(item => {
                    let oneDay = this.yearWeek[item.weeks-1].month + '.' + this.yearWeek[item.weeks-1].date,
                        lastDay = this.yearWeek[item.weeks-1].last.month + '.' + this.yearWeek[item.weeks-1].last.date;
                    return oneDay + '-' + lastDay + '&' + '第' + item.weeks + '周'
                })
            } else if (value == 6) {
                data1 = data.map(item => {
                    return item.months
                    // return item.months.split('-')[1] + '月'
                })
            }
            data2 = data.map(item => {
                return item.price_order
            })
            options.xAxis.data = data1;
            options.series[0].data = data2;
            this.chargeEchart.setOption(options);
        },
        initEchartData (data) {
            let options = data.options;
            let params = { 
                options,
                shop_id: this.shop_id == 'all' ? this.shop_id_list.join(',') : this.shop_id 
            };
            return new Promise((resolve, reject) => {
                getEcharts(params)
                    .then(res => {
                        if (res.data.code == 0) {
                            resolve(res)
                        } else {
                            reject(res.data)
                        }
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        getStatistics () {
            let params = {
                shop_id: this.shop_id == 'all' ? this.shop_id_list.join(',') : this.shop_id 
            }
            this.loading = true;
            getStatistics(params)
                .then(res => {
                    if (res.data.code == 0) {
                        let { data } = res.data;
                        this.all_sum = parseFloat(data.all_sum);
                        this.month_sum = parseFloat(data.month_sum);
                        this.yesterday_price = parseInt(data.yesterday_price);
                        this.end_yesterday_price = parseInt(data.end_yesterday_price);
                        this.data = data.ranking_list.map((item, index) => {
                            return {...item, ranking: index+1}
                        });
                        if (data.yesterday_price && (data.yesterday_price+'').indexOf('.') > -1) {
                            this.suffix1 = '.' + data.yesterday_price.split('.')[1];
                        }
                        if (data.end_yesterday_price && data.end_yesterday_price.indexOf('.') > -1) {
                            this.suffix2 = '.' + data.end_yesterday_price.split('.')[1];
                        }
                    } else {
                        this.$message.error(res.data.msg);
                    }
                })
                .catch(err => {
                    this.$message.error(err.msg);
                })
                .finally(_ => {
                    this.loading = false;
                })
        }
    },
    mounted () {
        this.yearWeek = whichWeek(new Date().getFullYear());
        window.onresize = () => {
            this.chargeEchart.resize();
            this.salesEchart.resize();
        };
        if (getShopStorage()) {
            this.shop_opt = getShopStorage();
            this.shop_id_list = this.shop_opt.map(sp => { return sp.shop_id })
            this.getStatistics();
            this.initEchart({ value2: 1, options: '1' });
            this.initEchart({ value2: 2, options: '4' });
        } else {
            this.$confirm('您还没有自己的店铺哦，快去申请店铺吧！','提示',{
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                callback: action => {
                    if (action == 'confirm') {
                        this.$router.push({ path: "/home/shopManage" });
                    }
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
    #dashboard {
        min-width: 1260px;
        .title {
        box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
        width: 100%;
        background: #fff;
        padding: 15px 32px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        p {
            font-size: 16px;
            color: #333;
            margin-left: 32px;

            span {
                color: #e72f0d;
                padding: 0 5px;
            }

            &:first-child {
                font-size: 18px;
                color: #333;
                margin-left: 0;
            }

            &:nth-child(2) {
                span {
                    color: #2448ff;
                }
            }
        }
    }
        .chart {
            margin-left: 24px;
            margin-top: 12px;
            margin-right: 24px;
            .chart-title {
                line-height: 36px;
                font-size: 18px;
                text-indent: 12px;
                font-weight: 600;
            }
            .data-show {
                display: flex;
                justify-content: space-around;
                padding-top: 30px;
                .show-span {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    height: 150px;
                    .ring {
                        border-radius: 50%;
                        padding: 15px;
                    }
                    .ring1 {
                        border: 2px solid #fb7369;
                    }
                    .ring2 {
                        border: 2px solid #48eadc;
                    }
                    .ring3 {
                        border: 2px solid #a46ded;
                    }
                    .ring4 {
                        border: 2px solid #ffc066;
                    }
                    .key {
                        font-size: 14px;
                        line-height: 36px;
                    }
                    .value {
                        font-size: 20px;
                        font-weight: 600;
                        line-height: 36px;
                    }
                }
            }
            .chart-data {
                margin-top: 12px;
                margin-bottom: 77px;
                .chart-title {
                    display: flex;
                    justify-content: space-between;
                    .title {
                        font-weight: 500;
                        font-size: 18px;
                    }
                    .chart-tabs {
                        width: 285px;
                    }
                }
                .table-title {
                    font-size: 24px;
                    font-weight: 600;
                    margin-bottom: 12px;
                    text-indent: 10px;
                }
            }
        }
    }

    ::v-deep .el-tabs__active-bar {
        width: 88px !important;
    }

    ::v-deep .el-col-16 {
        padding-right: 0 !important;
    }
</style>